
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class AppLogo extends Vue {}
